import { useState, useEffect } from 'react';
import makeRequest from '@jg/http-client';
import oneSearchDataTransform, {
  oneSearchDataTransformType,
} from '../utils/oneSearchDataTransform';
import config from '../config';

interface FetchResponse<TData> {
  loading: boolean;
  error?: boolean;
  data?: TData;
}

function useOneSearch(
  searchTerm: string,
  filterType: string,
  limit = 3,
  minCharacters = 2,
): FetchResponse<oneSearchDataTransformType> {
  const [data, setData] = useState<oneSearchDataTransformType | undefined>(
    undefined,
  );
  const [error, setError] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const url = `${config.oneSearchAPI}?limit=${limit}${
    filterType ? `&i=${filterType}` : ''
  }&includepublic=true&q=${searchTerm}*`;

  useEffect(
    () => {
      async function requestData() {
        try {
          setLoading(true);
          setError(false);

          const response = await makeRequest(url, { credentials: 'omit' });
          let responseJson = await response.json();
          responseJson = oneSearchDataTransform(responseJson);
          setData(responseJson.slice(0, limit));
          setLoading(false);

          if (response && !response.ok) {
            setError(true);
          }
        } catch (e) {
          setData(undefined);
          setError(true);
          setLoading(false);
        }
      }

      if (searchTerm.length <= minCharacters) {
        setData(undefined);
      } else {
        requestData();
      }
    },
    [searchTerm, filterType, limit, minCharacters],
  );

  return { data, loading, error };
}

export default useOneSearch;
